import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button } from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import personOutline from "@iconify/icons-eva/person-outline";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import TopupDialog from "src/components/dialogs/TopupDialog";
import PointTopupDialog from "src/components/dialogs/PointTopupDialog";
import UserChargeDialog from "src/components/dialogs/UserChargeDialog";
import UIAvatar from "src/components/common/UIAvatar";
import { asyncRequest } from "src/services/network";
import SharesDialog from "src/components/dialogs/SharesDialog";
import UserInfo from "src/components/common/UserInfo";
import PointReleaseDialog from "src/components/dialogs/PointReleaseDialog";
import SalaryDialog from "src/components/dialogs/SalaryDialog";
import TitleDialog from "src/components/dialogs/TitleDialog";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
import StaffAddDialog from "src/components/dialogs/StaffAddDialog";

const TABLE_HEAD = [
  { id: "uid", label: "UID", alignRight: false },
  { id: "nickname", label: "头像昵称", alignRight: false },
  // { id: "mobile", label: "手机号", alignRight: false },
  { id: "org", label: "职位", alignRight: false },
  // { id: "balance", label: "消费券", alignRight: false },
  // { id: "points", label: "积分", alignRight: false },
  { id: "points", label: "未发放消费券", alignRight: false },
  // { id: "createdAt", label: "注册时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  { title: "编辑", icon: personOutline },
  // { title: "设置职位", icon: personOutline },
  // { title: "发工资", icon: personOutline },
  { title: "解除", icon: personOutline },
];

export default function StaffList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [targetUser, setTargetUser] = useState({});
  const [action, setAction] = useState("");

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  const [form, setForm] = useState({
    uid: "",
    orgId: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/user/staff/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/edit/${row.uid}`, { state: row });
      setTargetUser(row);
      setAction("edit");
    } else if (type === "发工资") {
      setTargetUser(row);
      setAction("pay");
    } else if (type === "解除") {
      handleDel(row);
    } else if (type === "设置职位") {
      // handleDel(row);
      setTargetUser(row);
      setAction("title");
    }
  };

  function handleDel({ uid }) {
    Confirm({
      message: "确定解除员工职位吗?",
      async onConfirm() {
        await asyncRequest({
          path: "/user/staff/del",
          data: { uid },
        });

        getItems();
      },
    });
  }

  function handleAddStaff() {
    setAction("add");
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="员工列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            员工列表
          </Typography>

          {/* <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddStaff()}>
            添加员工
          </Button> */}
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { uid, avatar, nickname, group, realname, balance, pointsSalary, org, muted, blocked, acceleration, createdAt, mobile } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;
                    return (
                      <TableRow hover key={uid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                           <Checkbox
                             checked={isItemSelected}
                             onChange={(event) => handleClick(event, uid)}
                           />
                         </TableCell> */}
                        <TableCell align="left">{uid}</TableCell>

                        <TableCell component="th" scope="row">
                          <UserInfo avatar={avatar} uid={uid} nickname={nickname} />
                        </TableCell>
                        {/* <TableCell align="left">{mobile}</TableCell> */}
                        <TableCell align="left">{org ? org.name : ""}</TableCell>
                        {/* <TableCell align="left">{balance}</TableCell> */}
                        <TableCell align="left">{pointsSalary}</TableCell>

                        {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}

                        <TableCell align="right">
                          {/* <MoreMenu spread={true} menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} /> */}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <StaffAddDialog
        action={action}
        open={action === "add" || action === "edit"}
        staff={targetUser}
        onClose={() => setAction("")}
        onUpdate={() => {
          getItems();
          setAction("");
        }}
      />

      <TitleDialog
        open={action === "title"}
        onClose={() => setAction("")}
        onUpdate={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      />

      {action === "pay" && (
        <SalaryDialog
          open={action === "pay"}
          onClose={() => setAction("")}
          onUpdate={() => {
            getItems();
            setAction("");
          }}
          user={targetUser}
        />
      )}
    </Page>
  );
}
